import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DesignerContextMenu.less');
const cx = classnames.bind(styles);

export class DesignerMenuInfo
{
    constructor(public shouldShowMenu:boolean,
                public menuItems:MenuItem[],
                public menuPositionX:number,
                public menuPositionY:number)
    {
    }

    public static None():DesignerMenuInfo
    {
        return new DesignerMenuInfo(false, null, NaN, NaN);
    }
}

export interface DesignerContextMenuProps
{
    getPopupMenuInfo:() => (DesignerMenuInfo);
    onDismissed?:() => (void);
}

@observer
export class DesignerContextMenu extends React.Component<DesignerContextMenuProps, any>
{
    private _contextMenuId:string = IdUtil.newGUID();

    private _renderContextMenu(menuInfo:DesignerMenuInfo, onDismissed?:() => void)
    {
        const menuItems = menuInfo.menuItems;
        const clientRect = this._positionToClientRect(menuInfo);

        return <Popover id={this._contextMenuId}
                        onDismissed={onDismissed}
                        isModal={false}
                        popupSource={clientRect}
                        sourceAnchor={SourceAnchor.LeftTop}
                        popupAnchor={PopupAnchor.LeftTop}>

            <Column className={cx('designerContextMenu')}>
                {
                    menuItems.map((mi:MenuItem) =>
                    {
                        const Renderer = mi.renderer;
                        return <Renderer key={mi.id} menuItem={mi} handler={mi.handler} />;
                    })
                }
            </Column>
        </Popover>;
    }

    private _positionToClientRect(menuInfo:DesignerMenuInfo):ClientRect
    {
        const menuPositionX = menuInfo.menuPositionX;
        const menuPositionY = menuInfo.menuPositionY;
        const menuOffsetX = 10;
        const menuOffsetY = 10;
        const x = menuPositionX + menuOffsetX;
        const y = menuPositionY + menuOffsetY;

        // noinspection UnnecessaryLocalVariableJS
        const clientRect:ClientRect =
            {
                left: x,
                top: y,
                right: x,
                bottom: y,
                width: 0,
                height: 0
            };

        return clientRect;
    }

    render()
    {
        const {getPopupMenuInfo, onDismissed} = this.props;
        const info = getPopupMenuInfo();

        if( !info.shouldShowMenu )
            return null;

        return this._renderContextMenu(info, onDismissed);
    }
}
